
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useIsMobile } from '@/hooks/use-mobile';
import InternalRegistrationForm from '@/components/auth/InternalRegistrationForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const InternalRegistration = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleSpecialRequest = () => {
    // Navigate to the main register page with special request tab active
    navigate('/register', { 
      state: { 
        activeTab: 'special-request' 
      } 
    });
  };

  if (isMobile) {
    return (
      <div className="flex flex-col min-h-screen w-full bg-black">
        <MobileHeader />
        
        <main className="flex-grow w-full mt-24 py-6 px-4">
          <div className="container mx-auto max-w-md">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader className="text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <UserPlus className="h-6 w-6 text-sports-green" />
                  <CardTitle className="text-white">Create New School Account</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <InternalRegistrationForm onSpecialRequest={handleSpecialRequest} />
              </CardContent>
            </Card>
          </div>
        </main>
        
        <MobileBottomNav />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen w-full bg-black">
      <Header />
      
      <main className="flex-grow w-full mt-24 py-6 md:py-8 px-4 md:px-6">
        <div className="container mx-auto max-w-md">
          <Card className="bg-gray-900 border-gray-800">
            <CardHeader className="text-center">
              <div className="flex items-center justify-center gap-2 mb-2">
                <UserPlus className="h-6 w-6 text-sports-green" />
                <CardTitle className="text-white">Create New School Account</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <InternalRegistrationForm onSpecialRequest={handleSpecialRequest} />
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default InternalRegistration;
